<button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="!(notifications$ | async)?.length">
  <mat-icon [matBadgeHidden]="!(notifications$ | async)?.length" [matBadge]="(notifications$ | async)?.length" matBadgeColor="warn">notifications</mat-icon>
</button>

<mat-menu #menu="matMenu" class="notification-menu">
  <app-notifications [deleteOnDestroy]="true"
                     *ngIf="menuTrigger && menuTrigger.menuOpen"></app-notifications>
</mat-menu>
